"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.whitelabelOnly = exports.bimvitaOnly = exports.touchpointThemeOnly = void 0;
var common_mfe_1 = require("../../mfe/common-mfe");
var Themes_style_1 = require("../Themes.style");
// Currently touchpoint is not fully implemented throughout the code, it's just for demo purposes
function touchpointThemeOnly(themeFunction) {
    return "\n    ".concat(bimvitaOnly(themeFunction), "\n    ").concat(whitelabelOnly(themeFunction), "\n  ");
}
exports.touchpointThemeOnly = touchpointThemeOnly;
function bimvitaOnly(themeFunction) {
    var touchpoint = Themes_style_1.Touchpoints[common_mfe_1.TOUCHPOINTS.BIMVITA];
    return "\n    .".concat((0, common_mfe_1.getTouchpointThemeClass)(common_mfe_1.TOUCHPOINTS.BIMVITA), " & {\n      ").concat(themeFunction(touchpoint), "\n    }\n  ");
}
exports.bimvitaOnly = bimvitaOnly;
function whitelabelOnly(themeFunction) {
    var touchpoint = Themes_style_1.Touchpoints[common_mfe_1.TOUCHPOINTS.WHITELABEL];
    return "\n    .".concat((0, common_mfe_1.getTouchpointThemeClass)(common_mfe_1.TOUCHPOINTS.WHITELABEL), " & {\n      ").concat(themeFunction(touchpoint), "\n    }\n  ");
}
exports.whitelabelOnly = whitelabelOnly;
